import { render, staticRenderFns } from "./LanguageNotAvailableModal.vue?vue&type=template&id=4a09fb80&"
import script from "./LanguageNotAvailableModal.vue?vue&type=script&lang=js&"
export * from "./LanguageNotAvailableModal.vue?vue&type=script&lang=js&"
import style0 from "./LanguageNotAvailableModal.vue?vue&type=style&index=0&id=4a09fb80&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports